module.exports = __webpack_public_path__ + "static/sui-button-fluid-ffef9cf744331506ecf2d799b5c9e4aa.png";